/**
 * Created by tdunham on 2/7/2018.
 */

export class User {

	public id:              number;     // The ID of the user in the Angular ReST API.
	public email:           string;     // The user's email address.
	public fname:           string;     // The user's first name.
	public lname:           string;     // The user's family name.
	public password:        string;     // The user's password.
	public permissions:     number;     // What the user has access to.
	public persistence:     string;     // Persistent values stored for the user from session to session.
	public phone:           string;     // The user's phone number.
	public session_id:      string;     // The user's current session ID.
	public status:          string;     // A, C or S -- the user's current status (active, c?, suspended).
	public uname:           string;     // The user name.

	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}


}


// WEBPACK FOOTER //
// ./src/app/services/user/user.ts